import React, { useState } from "react";
import { useTranslation } from "react-i18next";

//Image
import images from "../../../Assets/images";

// css
import "../Modal/style.css";
import "../../../Assets/css/customize.css";

interface ModalProps {
  isOpen: boolean;
  deleteContent: string;
  closeModal: () => void;
  onConfirmAction: any;
  contentName: string;
  forAllRecurring?: boolean;
}

const DeleteConfirmationModal = ({
  isOpen,
  deleteContent,
  closeModal,
  contentName,
  onConfirmAction,
  forAllRecurring,
}: ModalProps) => {
  const { t } = useTranslation();
  const [deletedContent, setDeletedContent] = useState<string>(deleteContent);
  const closeModalOnClickOutSide = (e: any) => {
    e.target.classList.contains("modal") && closeModal();
  };
  return (
    <div id="" onClick={closeModalOnClickOutSide}>
      <div
        className={`custom-modal modal fade modal-backdrop fade  ${
          isOpen && "show"
        }`}
      >
        <div className="modal-dialog modal-sm modal-dialog-centered cust-new-modal">
          <div className="modal-content cust-new-proj-modal">
            <div className="modal-body p-0">
              <div className="del-modal-cont-wrapper">
                <div className="delmodal-content">
                  <div className="del-img-box">
                    {deletedContent.toLowerCase().includes("decline") ? (
                      <img src={images.closeIcon} alt="delete" />
                    ) : deletedContent.toLowerCase().includes("cancel") ||
                      deleteContent.toLowerCase().includes("user") ||
                      deleteContent.toLowerCase().includes("column config") ? (
                      <img src={images.RedDelete} alt="delete" />
                    ) : deletedContent.toLowerCase().includes("delete") ? (
                      <img src={images.RedDelete} alt="delete" />
                    ) : (
                      <img src={images.tickIcon} alt="delete" />
                    )}
                  </div>
                  <p className="conformation-text">
                    {deletedContent === "Column Config" && (
                      <>{t("Translation.column_config_are_you_sure")}</>
                    )}
                    {deletedContent === "Scheduled" && (
                      <>{t("Translation.part_of_recurring_approve")}</>
                    )}
                    {deletedContent === "DeleteBooking" && (
                      <>{t("Translation.are_you_sure_cancel_booking")}</>
                    )}
                    {deletedContent === "ConfirmCancel" && (
                      <>{t("Translation.are_you_sure_cancel_booking")}</>
                    )}
                    {deletedContent === "DeclineBooking" && (
                      <>{t("Translation.are_you_sure_decline_booking")}</>
                    )}
                    {deletedContent === "Cancelled" && (
                      <>{t("Translation.part_of_recurring_cancel")}</>
                    )}
                    {deletedContent === "Edit Recurring" && (
                      <>{t("Translation.part_of_recurring_edit")}</>
                    )}
                    {deletedContent === "Declined" && (
                      <>{t("Translation.part_of_recurring_decline")}</>
                    )}
                    {deletedContent === "Booking" && (
                      <>
                        {t("Translation.are_you_sure_cancel_booking")} $
                        {deletedContent} ?`
                      </>
                    )}
                    {deletedContent === "confirmCancelAll" && (
                      <>{t("Translation.are_you_sure_cancel_all_booking")}</>
                    )}
                    {deletedContent === "Delete User" && (
                      <>{t("Translation.remove_user_confirm") + contentName}</>
                    )}
                    {deleteContent === "Org User" && (
                      <>{t("Translation.remove_user_confirm") + contentName}</>
                    )}
                    {deleteContent === "Reinstate Booking" && (
                      <>{t("Translation.reinstate_booking_are_you_sure")}</>
                    )}
                    {(deleteContent === "EquipmentUsageDelete" ||
                      deleteContent === "CountryUomDelete" ||
                      deleteContent === "EquipmentDelete" ||
                      deleteContent === "VehicleEmissionDelete" ||
                      deleteContent === "VehicleDelete") &&
                      `${t("Translation.are_you_sure")} ${contentName} ?`}

                    {deletedContent !== "Booking" &&
                      deletedContent !== "Scheduled" &&
                      deletedContent !== "Column Config" &&
                      deletedContent !== "Cancelled" &&
                      deletedContent !== "Edit Recurring" &&
                      deletedContent !== "Declined" &&
                      deletedContent !== "DeleteBooking" &&
                      deletedContent !== "DeclineBooking" &&
                      deletedContent !== "Delete User" &&
                      deletedContent !== "confirmCancelAll" &&
                      deletedContent !== "ConfirmCancel" &&
                      deletedContent !== "Reinstate Booking" &&
                      deleteContent !== "Org User" &&
                      deleteContent !== "CountryUomDelete" &&
                      deleteContent !== "EquipmentDelete" &&
                      deleteContent !== "EquipmentUsageDelete" &&
                      deleteContent !== "VehicleEmissionDelete" &&
                      deleteContent !== "VehicleDelete" &&
                      `${t("Translation.are_you_sure")} ${deletedContent} ?`}
                  </p>
                  {deletedContent !== "Booking" &&
                    deletedContent !== "Scheduled" &&
                    deletedContent !== "Cancelled" &&
                    deletedContent !== "Edit Recurring" &&
                    deletedContent !== "Declined" &&
                    deletedContent !== "DeleteBooking" &&
                    deletedContent !== "DeclineBooking" &&
                    deletedContent !== "confirmCancelAll" &&
                    deletedContent !== "Reinstate Booking" &&
                    deletedContent !== "ConfirmCancel" && (
                      <p className="del-info">{t("Translation.cant_undo")}.</p>
                    )}
                </div>
                <div className="delmodal-cs-btnbox">
                  {deletedContent !== "Booking" &&
                    deletedContent !== "Scheduled" &&
                    deletedContent !== "Column Config" &&
                    deletedContent !== "Cancelled" &&
                    deletedContent !== "Edit Recurring" &&
                    deletedContent !== "Declined" &&
                    deletedContent !== "DeleteBooking" &&
                    deletedContent !== "DeclineBooking" &&
                    deletedContent !== "confirmCancelAll" &&
                    deletedContent !== "Delete User" &&
                    deletedContent !== "Delete User" &&
                    deleteContent !== "Resource" &&
                    deleteContent !== "Org User" &&
                    deleteContent !== "CountryUomDelete" &&
                    deleteContent !== "EquipmentDelete" &&
                    deleteContent !== "EquipmentUsageDelete" &&
                    deleteContent !== "VehicleEmissionDelete" &&
                    deleteContent !== "VehicleDelete" &&
                    deletedContent !== "ConfirmCancel" &&
                    !forAllRecurring && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 10,
                        }}
                      >
                        <button
                          className="theme-btn btn-default"
                          data-dismiss="modal"
                          onClick={() => closeModal()}
                        >
                          {t("Translation.no")}
                        </button>
                        <button
                          className="btn theme-btn "
                          onClick={() => onConfirmAction()}
                        >
                          {t("Translation.yes")}
                        </button>
                      </div>
                    )}
                  {deletedContent === "Column Config" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.close")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(6, false)}
                      >
                        {t("Translation.column_config_delete")}
                      </button>
                    </>
                  )}
                  {deletedContent === "Reinstate Booking" &&
                    forAllRecurring && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 10,
                        }}
                      >
                        <button
                          className="theme-btn"
                          data-dismiss="modal"
                          onClick={() => onConfirmAction(false)}
                        >
                          {t("Translation.this_only")}
                        </button>
                        <button
                          className="theme-btn"
                          onClick={() => onConfirmAction(true)}
                        >
                          {t("Translation.to_all_recurring")}
                        </button>
                      </div>
                    )}
                  {deletedContent === "DeleteBooking" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.close")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(6, false)}
                      >
                        {t("Translation.cancel_booking")}
                      </button>
                    </>
                  )}
                  {deletedContent === "ConfirmCancel" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.close")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(6, false)}
                      >
                        {t("Translation.cancel_booking")}
                      </button>
                    </>
                  )}
                  {deletedContent === "confirmCancelAll" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.close")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(6, true)}
                      >
                        {t("Translation.cancel_all_booking")}
                      </button>
                    </>
                  )}
                  {deletedContent === "Cancelled" && (
                    <>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        data-dismiss="modal"
                        onClick={() => setDeletedContent("ConfirmCancel")}
                      >
                        {t("Translation.this_only")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => setDeletedContent("confirmCancelAll")}
                      >
                        {t("Translation.to_all_recurring")}
                      </button>
                    </>
                  )}
                  {deletedContent === "Edit Recurring" && (
                    <>
                      <button
                        className="btn theme-btn "
                        data-dismiss="modal"
                        onClick={() => onConfirmAction("ConfirmEdit")}
                      >
                        {t("Translation.this_only")}
                      </button>
                      <button
                        className="btn theme-btn "
                        onClick={() => onConfirmAction("ConfirmEditAll")}
                      >
                        {t("Translation.to_all_recurring")}
                      </button>
                    </>
                  )}
                  {deletedContent === "Scheduled" && (
                    <>
                      <button
                        className="theme-btn"
                        data-dismiss="modal"
                        onClick={() => onConfirmAction(2, false)}
                      >
                        {t("Translation.this_only")}
                      </button>
                      <button
                        className="theme-btn"
                        onClick={() => onConfirmAction(2, true)}
                      >
                        {t("Translation.to_all_recurring")}
                      </button>
                    </>
                  )}
                  {deletedContent === "Declined" && (
                    <>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        data-dismiss="modal"
                        onClick={() => onConfirmAction(5, false)}
                      >
                        {t("Translation.this_only")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(5, true)}
                      >
                        {t("Translation.to_all_recurring")}
                      </button>
                    </>
                  )}
                  {deletedContent === "DeclineBooking" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.close")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(5, false)}
                      >
                        {t("Translation.decline_booking")}
                      </button>
                    </>
                  )}
                  {deletedContent === "Delete User" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.cancel")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(5, false)}
                      >
                        {t("Translation.remove")}
                      </button>
                    </>
                  )}
                  {deleteContent === "Resource" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.cancel")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(5, false)}
                      >
                        {t("Translation.remove")}
                      </button>
                    </>
                  )}
                  {deleteContent === "Org User" && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.cancel")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(5, false)}
                      >
                        {t("Translation.remove")}
                      </button>
                    </>
                  )}

                  {(deleteContent === "EquipmentUsageDelete" ||
                    deleteContent === "CountryUomDelete" ||
                    deleteContent === "EquipmentDelete" ||
                    deleteContent === "VehicleEmissionDelete" ||
                    deleteContent === "VehicleDelete") && (
                    <>
                      <button
                        className="theme-btn btn-default"
                        data-dismiss="modal"
                        onClick={() => closeModal()}
                      >
                        {t("Translation.cancel")}
                      </button>
                      <button
                        className="btn theme-btn cancel-booking-btn"
                        onClick={() => onConfirmAction(5, false)}
                      >
                        {t("Translation.remove")}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
